module.exports = __webpack_public_path__ + "static/media/luanna.e627c0bb.jpeg";